import React from 'react';
import { Mail, MapPin, MessageCircle, Phone } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageProvider';

const actions = [
  { label: 'Chiama', href: 'tel:+393493810464', icon: Phone },
  { label: 'Email', href: 'mailto:rosariopensabenearc@yahoo.it', icon: Mail },
  { label: 'Mappa', href: 'https://www.google.com/maps/search/?api=1&query=Viale+Regione+Siciliana+Nord+Ovest+2132+Palermo', icon: MapPin, external: true },
  { label: 'WhatsApp', href: 'https://wa.me/393493810464', icon: MessageCircle, external: true },
];

export default function ContactQuickActions() {
  const { t } = useLanguage();
  return <nav aria-label={t('Contatti rapidi')} className="grid grid-cols-2 gap-3 lg:hidden">
    {actions.map(({ label, href, icon: Icon, external }) => <a key={label} href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="flex min-h-12 items-center justify-center gap-2 border border-[#d8d8d8] bg-white px-3 text-sm text-[#2d2d2d] transition-colors duration-200 hover:bg-[#f8f8f8] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2d2d2d]">
      <Icon size={18} aria-hidden="true" />{t(label)}
    </a>)}
  </nav>;
}